var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConflictIndicator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.5L11.4 20.4L13.7625 18H7.5V15H13.7625L11.4 12.6L13.5 10.5L19.5 16.5L13.5 22.5ZM24 30C24.825 30 25.531 29.7065 26.118 29.1195C26.705 28.5325 26.999 27.826 27 27V6C27 5.175 26.706 4.469 26.118 3.882C25.53 3.295 24.824 3.001 24 3H17.7C17.375 2.1 16.831 1.375 16.068 0.825C15.305 0.275 14.449 0 13.5 0C12.551 0 11.6945 0.275 10.9305 0.825C10.1665 1.375 9.623 2.1 9.3 3H3C2.175 3 1.4685 3.294 0.880503 3.882C0.292501 4.47 -0.000997543 5.176 1.90735e-06 6V27C1.90735e-06 27.825 0.293503 28.5315 0.880503 29.1195C1.4675 29.7075 2.174 30.001 3 30H24ZM13.5 4.875C13.175 4.875 12.906 4.7685 12.693 4.5555C12.48 4.3425 12.374 4.074 12.375 3.75C12.376 3.426 12.4825 3.1575 12.6945 2.9445C12.9065 2.7315 13.175 2.625 13.5 2.625C13.825 2.625 14.0935 2.7315 14.3055 2.9445C14.5175 3.1575 14.624 3.426 14.625 3.75C14.626 4.074 14.5195 4.343 14.3055 4.557C14.0915 4.771 13.823 4.877 13.5 4.875Z",
    fill: "#0A3575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConflictIndicator);
export default __webpack_public_path__ + "static/media/conflict_indicator.43d243b7a630a2bc939b723adff2d94d.svg";
export { ForwardRef as ReactComponent };